export default __webpack_public_path__ + "static/media/uploadCn1.88eb2cef.jpg";